import {
  getDropdown,
  getMetadata,
  saveDropdown,
  saveMetadata,
} from "../db/indexedDB";
import apiClient from "../utils/ApiClient/apiClientAxios";

const CACHE_TTL = 1000 * 60 * 60 * 24; // 24 hours

export const getCodesWithCache = async (code, subgroup) => {
  const cached = await getDropdown(code, subgroup);
  const meta = await getMetadata(code, subgroup);
  const isExpired = !meta || Date.now() - meta > CACHE_TTL;

  if (cached && !isExpired) {
    return cached;
  }

  const { data } = await apiClient.get(`/getCodes?id=${code}`);
  await saveDropdown(code, subgroup, data);
  await saveMetadata(code, subgroup, Date.now());
  return data;
};
